var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120,
    height: "auto",
    viewBox: "0 0 172.913 59.528",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.152,55.632V17.987c0-9.266,5.638-14.275,15.539-14.836V40.093A15.584,15.584,0,0,1,213.152,55.632Zm-8.98,0V17.987c0-9.266-5.637-14.275-15.539-14.836V40.093A15.584,15.584,0,0,0,204.172,55.632Z",
    fill: "#fff",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 172.913,
    height: 59.528
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b",
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-185.672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.152,55.632V17.987c0-9.266,5.638-14.275,15.539-14.836V40.093A15.584,15.584,0,0,1,213.152,55.632Zm-8.98,0V17.987c0-9.266-5.637-14.275-15.539-14.836V40.093A15.584,15.584,0,0,0,204.172,55.632Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.438,
    transform: "translate(188.633 55.194)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 54.618)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 54.043)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 53.468)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 52.893)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 52.318)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 51.743)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 51.167)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 50.592)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 50.017)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 49.442)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 48.867)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 48.292)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 47.717)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 47.141)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 46.566)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 45.991)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 45.416)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 44.841)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 44.266)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 43.691)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 43.115)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 42.54)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 41.965)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 41.39)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 40.815)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 40.24)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 39.665)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 39.089)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 38.514)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 37.939)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 37.364)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 36.789)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 36.214)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 35.639)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 35.063)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 34.488)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 33.913)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 33.338)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 32.763)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 32.188)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 31.613)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 31.037)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 30.462)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 29.887)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 29.312)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 28.737)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 28.162)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 27.587)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 27.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 26.436)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 25.861)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 25.286)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 24.711)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 24.136)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 23.561)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 22.985)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 22.41)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 21.835)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 21.26)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 20.685)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 20.11)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 19.535)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 18.959)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 18.384)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 17.809)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 17.234)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 16.659)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 16.084)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 15.509)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 14.933)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 14.358)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 13.783)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 13.208)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 12.633)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 12.058)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 11.483)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 10.907)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 10.332)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 9.757)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 9.182)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 8.607)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 8.032)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 7.457)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 6.881)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 6.306)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 5.731)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 5.156)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 4.581)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 4.006)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.575,
    transform: "translate(188.633 3.431)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.539,
    height: 0.28,
    transform: "translate(188.633 3.151)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.438,
    transform: "translate(213.152 55.194)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 54.618)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 54.043)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 53.468)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 52.893)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 52.318)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 51.743)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 51.167)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 50.592)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 50.017)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 49.442)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 48.867)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 48.292)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 47.717)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 47.141)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 46.566)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 45.991)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 45.416)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 44.841)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 44.266)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 43.691)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 43.115)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 42.54)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 41.965)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 41.39)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 40.815)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 40.24)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 39.665)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 39.089)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 38.514)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 37.939)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 37.364)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 36.789)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 36.214)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 35.639)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 35.063)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 34.488)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 33.913)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 33.338)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 32.763)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 32.188)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 31.613)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 31.037)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 30.462)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 29.887)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 29.312)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 28.737)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 28.162)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 27.587)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 27.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 26.436)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 25.861)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 25.286)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 24.711)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 24.136)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 23.561)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 22.985)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 22.41)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 21.835)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 21.26)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 20.685)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 20.11)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 19.535)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 18.959)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 18.384)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 17.809)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 17.234)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 16.659)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 16.084)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 15.509)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 14.933)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 14.358)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 13.783)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 13.208)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 12.633)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 12.058)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 11.483)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 10.907)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 10.332)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 9.757)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 9.182)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 8.607)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 8.032)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 7.457)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 6.881)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 6.306)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 5.731)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 5.156)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 4.581)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 4.006)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.575,
    transform: "translate(213.152 3.431)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.538,
    height: 0.28,
    transform: "translate(213.152 3.151)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M209.258,44.3A2.711,2.711,0,0,1,211.36,47v7.678a2.734,2.734,0,0,1-2.733,2.734h-.054a2.477,2.477,0,0,1-2.476-2.476v-8.05A2.639,2.639,0,0,1,209.258,44.3Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.92,29.391a3.512,3.512,0,1,1-3.513-3.512A3.513,3.513,0,0,1,242.92,29.391Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.321,38.387h11.467a2.094,2.094,0,1,0,0-4.188H263.321a9.374,9.374,0,0,1,0-18.747h15a3.668,3.668,0,0,1,3.663,3.663,2.094,2.094,0,1,0,4.189,0,7.86,7.86,0,0,0-7.851-7.851h-15a13.562,13.562,0,1,0,0,27.123Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.378,26.7a13.476,13.476,0,0,0-9.59-3.972H263.321a2.094,2.094,0,1,0,0,4.189h11.467a9.373,9.373,0,1,1,0,18.746h-15A3.667,3.667,0,0,1,256.125,42a2.094,2.094,0,0,0-4.189,0,7.861,7.861,0,0,0,7.851,7.852h15a13.562,13.562,0,0,0,9.59-23.152Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.39,11.28H290.733a2.132,2.132,0,0,0,0,4.263h12.7v32.18a2.131,2.131,0,1,0,4.262,0V15.543h12.7a2.132,2.132,0,0,0,0-4.263Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.279,49.855H334.492A11.97,11.97,0,0,1,322.536,37.9V23.163a11.9,11.9,0,0,1,11.882-11.882h11.861a10.069,10.069,0,0,1,10.058,10.057,2.132,2.132,0,0,1-4.263,0,5.8,5.8,0,0,0-5.8-5.794H334.418a7.628,7.628,0,0,0-7.619,7.619V37.9a7.7,7.7,0,0,0,7.693,7.693h11.787a5.8,5.8,0,0,0,5.8-5.794,2.132,2.132,0,0,1,4.263,0A10.069,10.069,0,0,1,346.279,49.855Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlogo);
export default __webpack_public_path__ + "static/media/flogo.6c9fe20cfe199ba55620084694e6f48d.svg";
export { ForwardRef as ReactComponent };